import styled from 'styled-components'

export const NoFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 10px;
  line-height: var(--bq-font-line-height--large);
  font-style: normal;
  padding-top: var(--bq-spacing-l);
`

export const NoFoundTitle = styled.h5`
  color: var(--text-primary, #263139);
  font-size: var(--bq-font-size--xl);
  font-weight: var(--bq-font-weight--bold);
`

export const NoFoundTitleDetail = styled.span`
  color: var(--text-primary, #263139);
  text-align: center;
  font-variant-numeric: lining-nums tabular-nums;
  font-size: var(--bq-font-size--s);
  font-weight: var(--bq-font-weight--regular);
`
